module.exports = __webpack_public_path__ + "static/img/37.4d5d908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/37.jpg
// module id = Gaaa
// module chunks = 0